const CacheKeys = {
    deliveryAddressKey: 'deliveryAddress',
    invoiceAddressKey: 'invoiceAddress',
    shipToDifferentAddress: 'shipToDifferentAddress'
};

export default CacheKeys;